import { AttributeFormState } from '@idw-types/state/attribute-form-state';
import { FormikErrors } from 'formik';
import { FocusEvent, useMemo } from 'react';
import { BioGovOrKbaSelectInput } from './bio-gov-or-kba-select-input';
import { useSelector } from 'react-redux';
import { getLanguageContent } from '@redux/selectors/language-selectors';
import { SelectOption } from '@iddataweb/idw-common-ui/types';

type BioGovOrKbaSelectionAttributeProps = {
    title: string;
    attribute: AttributeFormState;
    fieldName: string;
    fieldTouched: boolean;
    fieldError: string;
    fieldIsInvalid: boolean;
    fieldShouldBeHighlighted: boolean;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
    onBlur: (event: FocusEvent<HTMLInputElement>) => void;
    onSetSubmitValue: (data: any) => void;
    isSubmitting: boolean;
};

export const BioGovOrKbaSelectionAttribute = (props: BioGovOrKbaSelectionAttributeProps) => {
    const {
        title,
        attribute,
        fieldName,
        fieldTouched,
        fieldError,
        fieldIsInvalid,
        fieldShouldBeHighlighted,
        setFieldValue,
        setFieldTouched,
        onBlur,
        onSetSubmitValue,
        isSubmitting
    } = props;

    const content = useSelector(getLanguageContent);

    const selectOptions: Array<SelectOption> = useMemo(() => {
        return [
            {
                label: content.form.pickerInput.kbaOptionLabel,
                value: 'kba',
                id: 'option-kba'
            },
            {
                label: content.form.pickerInput.bioGovOptionLabel,
                value: 'biogov',
                id: 'option-biogov'
            }
        ];
    }, [content]);

    return (
        <div>
            <BioGovOrKbaSelectInput
                title={title}
                options={selectOptions}
                attribute={attribute}
                fieldName={fieldName}
                fieldTouched={fieldTouched}
                fieldError={fieldError}
                fieldIsInvalid={fieldIsInvalid}
                fieldShouldBeHighlighted={fieldShouldBeHighlighted}
                onBlur={onBlur}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                onSetSubmitValue={onSetSubmitValue}
                isSubmitting={isSubmitting}
            />
        </div>
    );
}
